import { EventEmitter, Injectable } from '@angular/core';

import { assign } from 'lodash-es';
import { pick } from 'lodash-es';

import { CODE_EDITOR_EVENTS } from './events';

@Injectable()
export class CodeEditorEventService {
    public eventNames = Object.keys(CODE_EDITOR_EVENTS);
    private _events: any = {}; // 使用事件

    /**
     * 设置启用事件
     * @param  事件
     */
    addEvent(event){
        assign(this._events, event);
        // console.log(this.events);
    }

    fireEvent(event) {
        this._events[event.eventName].emit(event);
        // console.log("Emit Event:" + event);
    }
}
